<div class="content">
  <div class="content__container">
    <h3 class="content__container__title">{{data.title}}</h3>
    <div class="content__container__text">
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="fact_container">
        <p class="content__container__fact__title">Did you know?</p>
        <div cbCarousel colorTheme="default">
          <p-carousel
            [value]="data.facts"
            [circular]="true"
            [autoplayInterval]="8000"
            [numVisible]="1"
            [numScroll]="1"
            [showNavigators]="false"
            [showIndicators]="false">
              <ng-template pTemplate="item" let-item>
                <p class="carousel__container__slide__top__content__text1">{{ item.InsuranceFact }}</p>
              </ng-template>
          </p-carousel>
        </div>
      </div>
    </div>
  </div>
</div>